'use client';

import { useContentfulLiveUpdates } from '@contentful/live-preview/react';

import { useCollectionPageView } from '@/modules/product/hooks/useCollectionPageView';
import { ContentfulCollection } from '@/modules/product/models/collection.interface';

import { CollectionRoomContent } from '../components/collection-room/CollectionRoomContent';
import { CollectionRoomHeader } from '../components/collection-room/CollectionRoomHeader';
import { CollectionProvider } from '../context/CollectionRoomContext';

type CollectionRoomPageContentProps = {
  readonly collection: ContentfulCollection;
};

export default function CollectionRoomPageContent({ collection }: CollectionRoomPageContentProps) {
  const liveCollection = useContentfulLiveUpdates(collection);

  useCollectionPageView(liveCollection);

  return (
    <main
      className="mx-auto flex max-w-[1920px] flex-col py-4 lg:pb-10 lg:pt-8"
      data-collection-roomtype={liveCollection?.roomType || ''}
      data-collection-type="room"
    >
      <CollectionProvider collection={liveCollection}>
        <CollectionRoomHeader collection={collection} />
        <div className="mt-12">
          <CollectionRoomContent />
        </div>
      </CollectionProvider>
    </main>
  );
}
